<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <user-auth-class-control></user-auth-class-control>
      <user-auth-class-view></user-auth-class-view>
    </v-layout>
  </v-container>
</template>

<script>
import UserAuthClassControl from "@/components/userAuthClasses/userAuthClassControl";
import UserAuthClassView from "@/components/userAuthClasses/userAuthClassView";
export default {
  components: {
    UserAuthClassControl,
    UserAuthClassView
  }
};
</script>

<style>
</style>
